import React, { useImperativeHandle, forwardRef, useState } from 'react';

import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  DialogContent,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  content: {
    padding: 0,
    margin: 0,
    height: 'calc(100vh - 64px)', // ajusta pra caber abaixo da AppBar
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 56px)', // altura da AppBar no mobile
    },
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
}));

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogoPassadorLotes = forwardRef(
  ({ handleClose, handleSalvar }, ref) => {
    const [open, setOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const classes = useStyles();

    useImperativeHandle(ref, () => ({
      handleOpen(boleto, isLink) {
        setOpen(true);
        if (isLink) {
          setPdfUrl(boleto);
        } else {
          const url = URL.createObjectURL(boleto); // Cria um link temporário
          setPdfUrl(url);
        }
      },
    }));

    function handleCloseDialog() {
      setOpen(false);
      setPdfUrl(null);
    }

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleCloseDialog}
          fullScreen
          TransitionComponent={Transition}
          keepMounted
        >
          {/* ✅ Barra do topo */}
          <AppBar className={classes.appBar}>
            <Toolbar>
              <Typography variant="h6" className={classes.title}>
                Visualizador de PDF
              </Typography>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleCloseDialog}
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>

          {/* ✅ PDF ocupa toda a área abaixo da barra */}
          <DialogContent className={classes.content}>
            {pdfUrl && (
              <iframe
                src={`${pdfUrl}`} // remove toolbar preta do Chrome, opcional
                title="Visualizador de PDF"
                className={classes.iframe}
              />
            )}
          </DialogContent>
        </Dialog>
      </div>
    );
  },
);

export default DialogoPassadorLotes;
